import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { Ente } from "../types"
import { API_URL } from "../constants"

export function useEntiList(params: Record<string, string> = {}) {
  return useList<Ente>(`${API_URL}/enti`, {
    query: params,
  })
}

export function useEnte(id: number | undefined | string) {
  return useDetail<Ente>(`${API_URL}/enti`, id?.toString())
}

export function useEnteCreate() {
  return useCreate<Ente>(`${API_URL}/enti`)
}

export function useEnteUpdate() {
  return useUpdate<Ente>(`${API_URL}/enti`)
}

export function useEnteDelete() {
  return useDelete<Ente>(`${API_URL}/enti`)
}

